import React from 'react';
const Footer = () =>{
    return(
        <>
<footer className='bg-light w-100 mt-5 text-center'>
    <p>© 2021 RAJA'S Academy.All Rights Reserved | Terms and Conditions</p>
</footer>
        </>
    )
}
export default Footer;